import gql from "graphql-tag";

export const createDealerIncentiveMutation = gql`
  mutation createDealerIncentive(
    $name: String!
    $description: String!
    $startsAt: Timestamp!
    $endsAt: Timestamp!
    $measurementUnit: DealerIncentiveMeasurementUnit!
    $targetValue: Float!
    $reward: String!
    $color: String!
    $typeId: ID!
    $files: SyncAssociations
  ) {
    createDealerIncentive(
      name: $name
      description: $description
      startsAt: $startsAt
      endsAt: $endsAt
      measurementUnit: $measurementUnit
      targetValue: $targetValue
      reward: $reward
      color: $color
      typeId: $typeId
      files: $files
    ) {
      id
    }
  }
`;

export const createDealerIncentiveTypeMutation = gql`
  mutation createDealerIncentiveType($name: String!) {
    createDealerIncentiveType(name: $name) {
      id
      name
    }
  }
`;
